<script setup>
  import InvoiceForm from '../invoice/AddNew';
  import PaymentForm from '../invoice/Payment';
  import Totals from '../invoice/Totals';
  import InvoiceLines from '../../lists/InvoiceLines';
</script>

<template>
  <div
    data-component-group="invoice-form"
    data-component="edit"
    class="elevation-1"
  >
    <div class="component-body">
      <InvoiceForm
        :invoice="invoice"
        confirm-trigger-label="Update invoice"
        :is-disabled="true"
        :is-loading="isLoading"
        :on-submit="() => {}"
      >
        <template v-slot:beforeForm>
          <layout-section-header title="Details" :has-trigger="false" />
        </template>
      </InvoiceForm>

      <div class="invoice-pdf">
        <layout-section-header
          title="Invoice PDF"
          trigger-label="Download"
          class="elevation-1"
          @toggle="onDownloadPdf"
        />
      </div>

      <PaymentForm
        :invoice="invoice"
        confirm-trigger-label="Update payment"
        :is-disabled="true"
        :is-loading="isLoading"
        :on-submit="onSubmit"
      >
        <template v-slot:beforeForm>
          <layout-section-header
            title="Payment information"
            :has-trigger="false"
          />
        </template>
      </PaymentForm>

      <InvoiceLines :items="invoiceLines" :currency="invoiceCurrency">
        <template v-slot:beforeForm>
          <layout-section-header title="Invoice lines" :has-trigger="false" />
        </template>
      </InvoiceLines>

      <Totals :invoice="invoice">
        <template v-slot:beforeForm>
          <layout-section-header title="Totals" :has-trigger="false" />
        </template>
      </Totals>
    </div>
  </div>
</template>

<script>
  import defaultPagination from '../../../config/pagination';
  import { isObj } from '@/utils';
  import fetchIfNotInStoreMixin from '@/mixins/fetchIfNotInStore';

  // TODO: Translate component

  export default {
    mixins: [fetchIfNotInStoreMixin],
    props: {
      isLoading: {
        type: Boolean,
        default: false,
      },
      onCancel: {
        type: Function,
        default: undefined,
      },
      onSubmit: {
        type: Function,
        default: undefined,
      },
    },
    data() {
      return {
        pagination: {
          ...defaultPagination,
        },
      };
    },
    computed: {
      invoice() {
        return this.$store.getters['creatorProgram/activeInvoice'];
      },
      invoiceLines() {
        const { lines = [] } = this.invoice || {};
        return lines;
      },
      invoiceCurrency() {
        const { currency = {} } = this.invoice.cost_center || {};
        return currency;
      },
    },
    watch: {
      '$route.params.id': {
        handler(nextVal) {
          if (nextVal) {
            this.fetchIfNotInStore(nextVal,'creatorProgram', 'invoices', 'getInvoice');
          }
        },
        deep: true,
        immediate: true,
      },
      invoice(nextInvoice) {
        if (isObj(nextInvoice)) {
          this.pagination = defaultPagination;
        }
      },
    },
    methods: {
      onDownloadPdf() {
        const { id, invoice_number } = this.invoice;
        const query = { id, invoice_number };
        const action = this.isCreatorProgramPage ? 'creatorProgram/downloadInvoice' : 'invoices/downloadInvoice';

        return this.$store.dispatch(action, query);
      },
    },
  };
</script>

<style lang="scss" scoped>
@use 'sass:map';
@use '../../../assets/styles/theme' as *;

[data-component-group='invoice-form'][data-component='edit'] {
  .v-btn {
    margin: 0;
  }

  .invoice-pdf {
    [data-component='section-header'] {
      padding: $spacing-xl;
      background-color: map.get($colors, shades, 'white');
      border-top: 1px solid map.get($colors, grey, lighten-2);
    }
  }
}
</style>
